// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__NzGeQ","tooltip":"Tooltip_tooltip__LJE_u","arrow":"Tooltip_arrow___Gm6e"};